var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export-pdf-container"},[_c('div',{staticStyle:{"padding":"40px 40px 0 40px"}},[_c('img',{attrs:{"src":'img/imgPdf/aboutprogram.png',"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }